import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Number$isNaN from "@babel/runtime-corejs3/core-js/number/is-nan";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { each } from "lodash";
import numeral from "numeral";
import { round } from "../../../utils/utils";
import { debounce } from "lodash";

/**
 * This function evaluates a given calculated expression in a given scope:
 *
 * given the scope: {foo: 1, bar: 2}
 * and the expression: "foo + bar"
 *
 * evaluateCalc(scope, expression) => 3
 *
 * @param {Object} scope Root variables to evaluate from
 * @param {String} expression Expression to evaluate
 */
const evaluateCalc = (scope, expression) => {
  try {
    //A new function is required to manipulate its scope using the with operator
    const evalInScope = (scr, context) => {
      return new Function("with(this) { return " + scr + "}").call(context);
    };
    const result = evalInScope(expression, scope);
    //Math expressions could result in +/-Infinity, NaN or Null, we need to make sure to return 0 in those cases
    //The ternary operator is needed because +/-Infinity is truthy
    return isFinite(result) ? result || 0 : 0;
  } catch (e) {
    return 0;
  }
};
const debounceInputEvent = debounce((vNode, value) => {
  vNode.componentInstance.$emit("input", value);
}, 500, {
  leading: true,
  trailing: false
});
export default {
  componentUpdated(el, binding, vNode) {
    numeral.locale("en");
    const expression = binding.expression;
    //The scope in which we evaluate the expression is the vue-field-json-schema model,
    // which is the root object containing all the values of the form, a spread is needed
    // to get rid of its watchers/proxies
    const scope = _objectSpread({}, vNode.context.vfjsModel);
    let scopeWithNumbers = {};
    each(scope, (value, key) => scopeWithNumbers[key] = numeral(value)._value);
    let result = evaluateCalc(scopeWithNumbers, expression);
    const resultValue = round(result);
    const isMaskInput = !!vNode.componentInstance.inputMask;
    let componentInstanceResult = isMaskInput ? vNode.componentInstance.value : result;

    //Stop execution if model already reflects result
    if (vNode.context.vfjsModel[vNode.context.vfjsFieldModelKey] == componentInstanceResult) {
      return;
    }
    if (!_Number$isNaN(resultValue)) {
      var _vNode$data, _vNode$data$props, _vNode$data2, _vNode$data2$props;
      if ((vNode == null ? void 0 : (_vNode$data = vNode.data) == null ? void 0 : (_vNode$data$props = _vNode$data.props) == null ? void 0 : _vNode$data$props.formatType) === "money") {
        result = result === 0 ? null : numeral(result).format("$0,0.00");
        componentInstanceResult = result === 0 ? null : numeral(componentInstanceResult.toString()).format("$0,0.00");
      }
      if ((vNode == null ? void 0 : (_vNode$data2 = vNode.data) == null ? void 0 : (_vNode$data2$props = _vNode$data2.props) == null ? void 0 : _vNode$data2$props.formatType) === "percentage") {
        result = result === 0 ? null : `${_parseFloat(result).toFixed(2)}%`;
        componentInstanceResult = result;
      }
      setTimeout(() => {
        vNode.parent.componentInstance.setVfjsFieldModel(result, vNode.context.vfjsFieldModelKey);
      }, 0);
      setTimeout(() => debounceInputEvent(vNode, result), 0);
    }
  }
};